import React from "react"
import styled from "styled-components"
import empty from "../common/assets/empty.svg"

const StyledEmpty = styled.div`
  width: 100%;
  margin: 30px auto;
  text-align: center;
  img {
    width: 160px;
    height: auto;
  }
  h1 {
    font-size: 20px;
    line-height: 40px;
    color: #7b7b7b;
    font-family: "Roboto";
    font-weight: 900;
    text-transform: uppercase;
  }
  p {
    font-size: 15px;
    line-height: 21px;
    color: #7b7b7b;
    font-family: "Roboto";
    font-weight: 100;
    text-align: center;
    max-width: 400px;
    display: block;
    margin: 0 auto;
  }
  @media screen and (max-width: 800px) {
    width: 80%;
    h1 {
      line-height: 30px;
    }
  }
`

function Empty() {
  return (
    <StyledEmpty className="Empty">
      <img src={empty} alt="empty box" />
      <h1>Your shopping cart is empty</h1>
      <p>
        Start adding items to your shopping cart through the search box above.
      </p>
    </StyledEmpty>
  )
}

export default Empty
